import React from 'react';
import { Period, PeriodTypeToString } from '../SessionPeriods';

type Props = {
  period: Period;
  startX?: number;
  endX?: number;
  timelineY: number;
  graphicWidth: number;
  graphicHeight: number;
};

const SessionTimelinePeriod = (props: Props) => {
  const { period, startX, endX, timelineY, graphicWidth, graphicHeight } = props;

  return (
    <>
      {/*Start period graphic*/}
      {startX && (
        <polygon
          points={
            startX +
            ',' +
            (timelineY - graphicHeight / 2) +
            ' ' +
            (startX + graphicWidth) +
            ',' +
            timelineY +
            ' ' +
            startX +
            ',' +
            (timelineY + graphicHeight / 2)
          }
          fill="#0a0"
          stroke="#000"
          strokeWidth={2}
        />
      )}
      {/*End period graphic*/}
      {endX && startX !== endX && (
        <polygon
          points={
            endX +
            ',' +
            (timelineY - graphicHeight / 2) +
            ' ' +
            (endX - graphicWidth) +
            ',' +
            timelineY +
            ' ' +
            endX +
            ',' +
            (timelineY + graphicHeight / 2)
          }
          fill="#a00"
          stroke="#000"
          strokeWidth={2}
        />
      )}
      {/*Period line*/}
      {startX && endX && startX !== endX && (
        <line
          x1={startX + graphicWidth}
          x2={endX - graphicWidth}
          y1={timelineY}
          y2={timelineY}
          strokeWidth={5}
          stroke="#aa0"
        />
      )}
      {/*Period text*/}
      {startX && endX && (
        <text
          x={startX + (endX - startX) * 0.5}
          y={timelineY - graphicHeight * 0.25}
          dominantBaseline="middle"
          textAnchor="middle">
          {PeriodTypeToString(period.type)} {period.label && ' ( ' + period.label + ' )'}
        </text>
      )}
    </>
  );
};

export default SessionTimelinePeriod;
